import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import routes from '../../utils/routes';
import strings from '../../utils/strings';
import { CText } from '../../components/common';

const Portfolio: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);

  const assets = [
    { name: strings.stock, value: '$12,450', change: '+5.2%', positive: true },
    { name: strings.crypto, value: '$8,320', change: '-2.1%', positive: false },
    { name: strings.gold, value: '$3,100', change: '+1.8%', positive: true },
    { name: strings.NFTs, value: '$1,977', change: '+8.3%', positive: true },
  ];

  return (
    <div
      className="p-4 md:p-6 lg:p-8 min-h-screen pb-24 lg:pb-8"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-5xl lg:mx-auto">
      <CText type="B24" color={colors.textColor} style={{ marginBottom: '24px' }}>
        {strings.portfolio}
      </CText>

      {/* Total Asset Card */}
      <div
        className="rounded-2xl p-5 md:p-6 mb-5"
        style={{
          background: `linear-gradient(135deg, ${colors.gradient1} 0%, ${colors.gradient2} 50%, ${colors.gradient1} 100%)`,
          color: colors.white,
        }}
      >
        <CText type="r12" color={colors.white} style={{ marginBottom: '8px' }}>
          {strings.totalAssetValue}
        </CText>
        <CText type="B32" color={colors.white} style={{ marginBottom: '16px' }}>
          $25,847.50
        </CText>
        <div className="flex items-center gap-2">
          <CText type="M14" color={colors.green}>{strings.profits}: +$1,247.50</CText>
          <CText type="r12" color={colors.white}>(+5.2%)</CText>
        </div>
      </div>

      <CText type="B18" color={colors.textColor} style={{ marginBottom: '16px' }}>
        Your Assets
      </CText>

      {/* Assets Grid - responsive */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {assets.map((asset) => (
          <div
            key={asset.name}
            className="rounded-xl p-4 border"
            style={{
              backgroundColor: colors.inputBackground,
              borderColor: colors.borderColor,
            }}
          >
            <CText type="r12" color={colors.grayScale500} style={{ marginBottom: '8px' }}>
              {asset.name}
            </CText>
            <CText type="B16" color={colors.textColor} style={{ marginBottom: '4px' }}>
              {asset.value}
            </CText>
            <CText
              type="M12"
              color={asset.positive ? colors.green : colors.alertColor}
            >
              {asset.change}
            </CText>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <CText
          type="M14"
          color={colors.primary}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(routes.portfolioHistory)}
        >
          View Transaction History →
        </CText>
      </div>
      </div>
    </div>
  );
};

export default Portfolio;
